import { render, staticRenderFns } from "./SearchOwner.vue?vue&type=template&id=5c7b4af0&scoped=true"
import script from "./SearchOwner.vue?vue&type=script&lang=js"
export * from "./SearchOwner.vue?vue&type=script&lang=js"
import style0 from "./SearchOwner.vue?vue&type=style&index=0&id=5c7b4af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b4af0",
  null
  
)

export default component.exports